module.exports = __webpack_public_path__ + "img/WP2023-RegFees-Inperson.8ab6647a.jpg";